import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { CanvasSprite } from "../../../../slot/Sprite/CanvasSprite";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { LogGroup, CreateElement, Scale, Size } from "../../../.././MyHelpers";
import { Slide, SlideFactory2Params } from "./Slide";
import { Settings } from "../../../../Settings";
import { ITranslatedCanvasParams, TranslatedCanvasSprite } from "../../../TranslatedCanvasSprite";
import { CommonTranslatedSprite } from "../../../CommonTranslatedSprite";

export class TurboPlay extends Slide {
    protected logGroup: LogGroup;
    protected resid: ResourceIdentifier;
    protected systemContext: ISystemContext;

    protected SripiteTimer: IInterval;
    protected SpriteRigth: CanvasSprite = null;

    protected SripiteTimerRight: IInterval;
    protected TurboPath: string = null;

    protected turboSpriteTranslator: CommonTranslatedSprite = null;

    constructor(initData: SlotGameInitData, p: SlideFactory2Params, viewSize: Size) {
        super(initData, p, viewSize);
        this.logGroup = this.p.logGroup.Add("TurboPlay");
        this.resid = this.p.resid.Add("TurboPlay");
        this.systemContext = this.p.systemContext.CreateSubContext("TurboPlay");
        this.viewSize = viewSize;
        this.view = CreateElement("div", {
            classes: ["TurboPlay", this.resid.Scope()],
            style: {
                position: "absolute",
                height: this.viewSize.Height + "px",
                width: this.viewSize.Width + "px",

                display: "flex",
                flexDirection: "column",
                flexShrink: "0",
            }
        });

        this.TurboPath = Settings.ResourcesFolder + "multigame/slot/common/resources/TurboGame/TurboGameRight";
        let params: ITranslatedCanvasParams = {
            resid: this.resid,
            path: this.TurboPath,
            logGroup: this.logGroup,
            viewSize: this.viewSize,
            nameSpriteSlide: "TurboGameRight",
            translator: this.translator,
        }
        this.turboSpriteTranslator = new TranslatedCanvasSprite(params);
    }




    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        this.turboSpriteTranslator.PrepareResources(resourceManager);
    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        this.turboSpriteTranslator.ResourcesLoaded(resourceManager);
        this.view.appendChild(this.turboSpriteTranslator.View());
        this.SripiteTimerRight = this.systemContext.TimingContext().CreateInterval("TurboGameRight", this.nextAnimInterval, () => this.turboSpriteTranslator.Start());
    }

    public override View(): HTMLElement {
        return this.view;
    }
    public override Update() {
        //this.SpriteRigth.Update();
        this.turboSpriteTranslator.Update();
    }
    public override Start() {
        this.SripiteTimerRight.Start();
    }

    public override Stop() {
        this.SripiteTimerRight.Stop();
        //this.SpriteRigth.StopAndReset();
    }
}